import LoginPage from "../components/Login/Login";

const Login = () => <LoginPage />;

export default Login;
